export default "__VITE_ASSET__CYUIC78P__"